/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Colactions2Inputs */

const zh_adminsubs_colactions2 = /** @type {(inputs: Adminsubs_Colactions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`操作`)
};

const en_adminsubs_colactions2 = /** @type {(inputs: Adminsubs_Colactions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

const es_adminsubs_colactions2 = /** @type {(inputs: Adminsubs_Colactions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acciones`)
};

/**
* | output |
* | --- |
* | "Actions" |
*
* @param {Adminsubs_Colactions2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_colactions2 = /** @type {((inputs?: Adminsubs_Colactions2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Colactions2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_colactions2(inputs)
	if (locale === "en") return en_adminsubs_colactions2(inputs)
	return es_adminsubs_colactions2(inputs)
});
export { adminsubs_colactions2 as "adminSubs_colActions" }